define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var colorAdminRoles = ['Color Administrator'];
	var materialUsageAdminRoles = ['Material Usage Administrator'];
	var materialAdminRoles = ['Material Administrator'];
	var productSpecAdminRoles = ['Product Specification Administrator'];
	var productSpecEditorRoles = productSpecAdminRoles.concat(['Product Specification Editor']);
	var bomCreatorRoles = ['TDS - BOM Creator','TDS - BOM Administrator'];
	var bomEditorRoles = bomCreatorRoles.concat(['TDS - BOM Editor']);
	var routingCreatorRoles = ['TDS - Routing Creator','TDS - Routing Administrator'];
	var tdsSpecCreatorRoles = ['TDS - Spec Creator','TDS - Spec Administrator'];
	const sustainabilityAdminRoles = ['Sustainability Administrator'];
	const tdsSustainabilityProfileAdminRoles = sustainabilityAdminRoles.concat(['TDS - Sustainability Profile Administrator']);
	const tdsSustainabilityProfileCreatorRoles = tdsSustainabilityProfileAdminRoles.concat(['TDS - Sustainability Profile Creator']);
	var colorRuleAdministrator = ["Color Rule Administrator"];

	csiAccess.addViewRoles({
		"_CS_ApparelViews":{
			"ColorMatchingTypes":{
				"NewColorMatchingType":access(full(colorRuleAdministrator))
			}
		},
		"Material":{
			"BOMs":{
				"Copy":access(full(productSpecAdminRoles), full(bomCreatorRoles)),
				"NewMaterialBOM":access(full(productSpecAdminRoles), full(bomCreatorRoles)),
				"NewFromMaterialBOM":access(full(productSpecAdminRoles), full(bomCreatorRoles))
			},
			"ColorDataSheets":{
				"Copy":access(full(materialAdminRoles), full(colorAdminRoles)),
				"AggregateColorDataSheets":access(full(materialAdminRoles), full(colorAdminRoles))
			},
			"SustainabilityProfiles": {
				"NewSustainabilityProfile":access(full(tdsSustainabilityProfileCreatorRoles)),
				"Copy":access(full(tdsSustainabilityProfileCreatorRoles)),
				"Delete":access(full(tdsSustainabilityProfileAdminRoles)),
			},
			"MaterialDataSheets":{
				"Copy":access(full(materialAdminRoles)),
				"NewMaterialDataSheet":access(full(materialAdminRoles)),
				"ColorDataSheets":access(full(materialAdminRoles)),
				"EndPhase|Child:CurrentRevision":access(full(materialAdminRoles))
			},
			"Routing":{
				"Copy":access(full(productSpecAdminRoles), full(routingCreatorRoles)),
				"NewRouting":access(full(productSpecAdminRoles), full(routingCreatorRoles)),
				"NewFromRoutings":access(full(productSpecAdminRoles), full(routingCreatorRoles)),
				"NewFromRoutingTemplates":access(full(productSpecAdminRoles), full(routingCreatorRoles))
			},
			"SpecificationDataSheets":{
				"Copy":access(full(productSpecAdminRoles), full(tdsSpecCreatorRoles)),
				"NewSpecificationDataSheet":access(full(productSpecAdminRoles), full(tdsSpecCreatorRoles)),
				"NewFromSpecificationDataSheet":access(full(productSpecAdminRoles), full(tdsSpecCreatorRoles)),
				"NewSpecificationDataSheetFromTemplate":access(full(productSpecAdminRoles), full(tdsSpecCreatorRoles))
			},
			"WhereUsedMaterialBOM":{
				"MassRefreshUnitCost":access(full(materialUsageAdminRoles)),
				"MassReplace":access(full(materialUsageAdminRoles)),
				"MassAddMaterial":access(full(materialUsageAdminRoles)),
				"MassCreateDependentPartMaterial":access(full(materialUsageAdminRoles)),
				"MassDeletePartMaterials":access(full(materialUsageAdminRoles))
			}
		},
		"Season":{
			"ColorMatchingRules":{
				"GenerateColorMatchingRulesFromThemes":access(full(colorRuleAdministrator)),
				"GenerateColorMatchingRulesFromAvailability":access(full(colorRuleAdministrator))
			},
			"MaterialFamilyColorRules":{
				"GenerateColorMatchingRulesFromThemes":access(full(colorRuleAdministrator)),
				"GenerateColorMatchingRulesFromAvailability":access(full(colorRuleAdministrator))
			}
		},
		"Theme":{
			"ColorMatchingRules":{
				"GenerateColorMatchingRules":access(full(colorRuleAdministrator))
			}
		}
	});
});